<template>
  <div class="legal wide-container">
    <h1 class="legal__title">
      <Lang by-key="general-condition-title" />
    </h1>

    <div class="legal__block">
      <p class="legal__block__body">
        <Lang by-key="general-condition-0-body-0" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="general-condition-0-body-1" />
      </p>

      <div class="legal__block__table">
        <div class="cell-header">
          <Lang by-key="identity" />:
        </div>
        <div class="cell">
          SPALOPIA, S.L. - B76681568
        </div>

        <div class="cell-header">
          <Lang by-key="address" />:
        </div>
        <div class="cell">
          Avenida Sor Soledad Cobian, 3, 38300 - Orotava, La
        </div>

        <div class="cell-header">
          <Lang
            by-key="email"
            capitalize-first
          />:
        </div>
        <div class="cell">
          <a href="mailto:ayuda@spalopia.com">
            <SplButton variant="link">
              ayuda@spalopia.com
            </SplButton>
          </a>
        </div>
      </div>

      <p class="legal__block__body">
        <Lang by-key="general-condition-0-body-2" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-1-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-1-body-0" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="general-condition-1-body-1" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="general-condition-1-body-2" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-2-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-2-body-0" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="general-condition-2-body-1" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="general-condition-2-body-2" />
      </p>

      <ul class="legal__block__list">
        <li><Lang by-key="general-condition-2-body-3" /></li>
        <li><Lang by-key="general-condition-2-body-4" /></li>
        <li><Lang by-key="general-condition-2-body-5" /></li>
        <li><Lang by-key="general-condition-2-body-6" /></li>
        <li><Lang by-key="general-condition-2-body-7" /></li>
      </ul>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-3-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-3-body-0" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-4-header" />
      </h3>

      <p class="legal__block__body highlight">
        <Lang by-key="general-condition-4-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-4-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-4-body-2" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-4-body-3" />
      </p>

      <p class="legal__block__body highlight">
        <Lang by-key="general-condition-4-body-4" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-4-body-5" />
      </p>

      <p class="legal__block__body highlight">
        <Lang by-key="general-condition-4-body-6" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-4-body-7" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-4-body-8" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-5-header" />
      </h3>

      <p class="legal__block__body highlight">
        <Lang by-key="general-condition-5-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-5-body-1" />
      </p>

      <p class="legal__block__body highlight">
        <Lang by-key="general-condition-5-body-2" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-5-body-3" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-6-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-6-body-0" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-7-header" />
      </h3>

      <p class="legal__block__body highlight">
        <Lang by-key="general-condition-7-body-00" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-7-body-01" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-7-body-02" />
      </p>

      <p class="legal__block__body highlight">
        <Lang by-key="general-condition-7-body-03" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-7-body-04" />
        <a
          class="ml-text"
          href="mailto:ayuda@spalopia.com"
        >
          <SplButton variant="link">
            ayuda@spalopia.com
          </SplButton>
        </a>
      </p>

      <p class="legal__block__body highlight">
        <Lang by-key="general-condition-7-body-05" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-7-body-06" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="general-condition-7-body-07" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-7-body-08" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="general-condition-7-body-09" />
      </p>
      <p class="legal__block__body highlight">
        <Lang by-key="general-condition-7-body-10" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="general-condition-7-body-11" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-7-body-12" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-8-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-8-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-8-body-1" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-9-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-9-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-9-body-1" />
        <SplNuxtLink
          is-external
          no-lang
          class="ml-text"
          to="/politica-de-privacidad/"
        >
          <SplButton variant="link">
            <Lang by-key="privacy-policy" />
          </SplButton>
        </SplNuxtLink>
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-10-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-10-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-10-body-1" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-11-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-11-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-11-body-1" />
      </p>

      <ul class="legal__block__list">
        <li><Lang by-key="general-condition-11-body-2" /></li>
        <li><Lang by-key="general-condition-11-body-3" /></li>
        <li><Lang by-key="general-condition-11-body-4" /></li>
        <li><Lang by-key="general-condition-11-body-5" /></li>
        <li><Lang by-key="general-condition-11-body-6" /></li>
      </ul>

      <p class="legal__block__body">
        <Lang by-key="general-condition-11-body-7" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-12-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-12-body-0" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-13-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-13-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-13-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-13-body-2" />
      </p>
    </div>

    <!-- https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.show&lng=ES -->

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-14-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-14-body-0" />
      </p>

      <p class="legal__block__body">
        <SplNuxtLink
          to="https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.show&lng=ES"
          no-lang
        >
          <SplButton variant="link">
            webgate.ec.europa.eu
          </SplButton>
        </SplNuxtLink>
      </p>

      <p class="legal__block__body">
        <Lang by-key="general-condition-14-body-1" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-15-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-15-body-0" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="general-condition-16-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="general-condition-16-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="general-condition-16-body-1" />
        <a
          class="ml-text"
          href="mailto:ayuda@spalopia.com"
        >
          <SplButton variant="link">
            ayuda@spalopia.com
          </SplButton>
        </a>
      </p>
    </div>

    <div class="legal__block">
      <p class="legal__block__body">
        <Lang
          capitalize-first
          by-key="version"
        />
        <span>: V.1.0</span>
      </p>
      <p class="legal__block__body">
        <Lang
          capitalize-first
          by-key="date"
        />
        <span>: 21/05/20</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import SplNuxtLink from '~/core/components/shared/SplNuxtLink.vue'
import SplButton from '~/core/components/shared/form/SplButton.vue'

import HeadMetaBuilder from '~/core/ts/util/HeadMetaBuilder'
import { translateByKey } from '~/core/ts/util/translate'

definePageMeta({
  layout: 'checkout',
})

export default defineNuxtComponent({
  components: {
    SplNuxtLink,
    SplButton,
  },
  setup() {
    const builder = HeadMetaBuilder.create()
    const title = translateByKey('general-condition-title')
    builder.withTitleAndMetaTitle(`${title} | Spalopia.com`)

    useHead(builder.get())

    return {}
  }
})
</script>

<style lang="scss" scoped>
@import url('./legal.scss');
</style>
